<!--
 * @Author: your name
 * @Date: 2021-09-06 14:39:34
 * @LastEditTime: 2021-09-15 15:54:55
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/components/commonComponents/TagComponent.vue
-->
<template>
  <!-- tag组件，根据不同tag样式需求，自定义color传参，class样式 -->
  <div :class="`tag-component ${color}`">
    <div>{{ text }}</div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: [String, Number],
      default: 'tag',
    },
    color: {
      type: String,
      default: 'yellow',
    },
  },
};
</script>

<style scoped lang="scss">
.tag-component {
  box-sizing: border-box;
  min-width: 96px;
  height: 40px;
  // padding: 0 2px;
  font-size: 22px;
  line-height: 40px;
  text-align: center;
  // border: 1.1px solid;
  // border-radius: 4px;
  //word-break:keep-all;
  //white-space:nowrap;
  // background: url('./../../assets/img/loginImg/discount-bg.png') no-repeat;
  background-size: 100%;
  > div {
    // transform: scale(0.98);
  }
}
.yellow {
  color: $theme_color;
  background: none;
  border: 1.1px solid $theme_color;
  border-radius: 8px;
}
.yellow-no-bg {
  background-color: $orangeBg;
  color: $liveColor;
  border-color: $theme_color;
  border-radius: 8px;
}
.gray {
  color: #666;
  border-color: #ececec;
}
.blue {
  background-color: $blueBg;
  color: $buleColor;
  border-radius: 8px;
}
</style>
